import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import AvtarImage from '../pages/profile/AvtarImage';
import { wordCapitalize } from '../utils/common';

const HrAvatarGroup = ({ assignedHRs = [] }) => {
  if (!assignedHRs || assignedHRs.length === 0) {
    return (
      <span className="text-muted" style={{ color: '#a5a8c5', fontSize: '13px' }}>
        --
      </span>
    );
  }

  const maxVisible = 3;
  const visibleHRs = assignedHRs.slice(0, maxVisible);
  const totalCount = assignedHRs.length;

  const allNames = assignedHRs
    .map((hr) => `${wordCapitalize(hr?.FirstName)} ${wordCapitalize(hr?.LastName)}`)
    .join(', ');

  return (
    <div
      className="hr-avatar-group-container"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        position: 'relative',
        paddingRight: totalCount > 1 ? '8px' : '0',
        paddingTop: totalCount > 1 ? '4px' : '0'
      }}>
      <div
        className="hr-avatar-stack"
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row'
        }}>
        {visibleHRs.map((hr, idx) => {
          const fullName = `${wordCapitalize(hr?.FirstName)} ${wordCapitalize(hr?.LastName)}`;
          return (
            <Tooltip title={fullName} key={hr?.ID || idx} arrow placement="top">
              <div
                style={{
                  marginLeft: idx === 0 ? 0 : -10,
                  zIndex: visibleHRs.length - idx,
                  position: 'relative'
                }}>
                <AvtarImage
                  firstName={hr?.FirstName}
                  lastName={hr?.LastName}
                  className="hr-avatar-item"
                />
              </div>
            </Tooltip>
          );
        })}
      </div>

      {totalCount > 1 && (
        <Tooltip title={`Assigned HRs (${totalCount}): ${allNames}`} arrow placement="top">
          <span
            className="hr-notification-badge"
            style={{
              position: 'absolute',
              top: '-3px',
              right: '-3px',
              backgroundColor: '#ea5455',
              color: '#ffffff',
              fontSize: '10px',
              fontWeight: 700,
              minWidth: '18px',
              height: '18px',
              padding: '0 4px',
              borderRadius: '999px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
              border: '2px solid var(--surface-card, #ffffff)',
              zIndex: 30,
              cursor: 'pointer'
            }}>
            {totalCount}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default HrAvatarGroup;
